import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-search\"><path d=\"M958.882306 936.255611l-282.925504-282.92588c57.169564-62.584844 92.043198-145.883669 92.043198-237.328931 0-194.404063-157.59589-352.000329-351.999953-352.00033-194.404439 0-352.000329 157.596266-352.000329 352.00033s157.59589 352.000329 352.000329 352.000329c91.446015 0 174.74484-34.87401 237.329684-92.04395l282.925504 282.92588c6.248023 6.2484 16.378295 6.2484 22.627071 0 6.2484-6.248023 6.2484-16.379424 0-22.627448zM96.000706 416.0008c0-176.730932 143.268786-320.000094 319.999717-320.000094 176.731308 0 320.00047 143.268786 320.000471 320.000094s-143.268786 320.000094-320.000471 320.000094c-176.730932 0-319.999718-143.268786-319.999717-320.000094z\" fill=\"\" p-id=\"4494\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/search.svg
// module id = Bx0U
// module chunks = 0